









































































import { Vue, Component, Watch } from "vue-property-decorator";
import { UserService } from "src/services";
import { IAppModel, IMenuModel, IUserLoginInfoModel } from "src/model";
import router from '../../../router';

@Component
export default class Shop extends Vue
{
    /**
     * 获取用户服务
     * @private
     * @return UserService
     */
    private _userService: UserService;

    /**
     * 弹框显示
     * @protected
     * @returns 
     */
    protected visible: boolean = false;

    /**
     * 机构列表
     * @protected
     * @returns 
     */
    protected dataList: Array<any> = [
        {
            id: 0,
            name: '体检解决方案',
            ms: '如果主营业务是体检，想为自己的服务拓展渠道以及开展检后管理，则选择此类别',
            icon: 'icontijianjiejuefangan iconfont',
            bgColor: '#1890FF',
            industryType: 1
        },
        {
            id: 1,
            name: '齿科',
            ms: '如果主营业务是口腔，需要增加销售渠道，拓展服务能力，搭建用户运营体系则选择此类别',
            icon: 'iconjiancefuwu iconfont',
            bgColor: '#ED122F',
            industryType: 2
        },
        {
            id: 2,
            name: '眼科',
            ms: '如果主营业务是眼科，需要增加销售渠道，拓展服务能力，搭建用户运营体系则选择此类别如果主营业务为开展慢病管理、体重管理等，需要补充服务能力，增加获客和客户运营能力则选择此类别',
            icon: 'iconyanke iconfont',
            bgColor: '#42B500',
            industryType: 3
        },
        {
            id: 3,
            name: '药店解决方案',
            ms: '如果主营业务为药品零售，希望拓展销售渠道，开展客户慢病管理业务，则选择次类别',
            icon: 'iconyaodianjiejuefangan iconfont',
            bgColor: '#019C79',
            industryType: 5
        },
        {
            id: 4,
            name: '检测服务',
            ms: '主营业务是基因检测、以及其他检测服务。可以成为health force数万家医疗以及健康管理机构的监测服务商，并增加TO C业务渠道',
            icon: 'iconchike iconfont',
            bgColor: '#AE4720',
            industryType: 7
        },
        {
            id: 5,
            name: '健康管理',
            ms: '如果主营业务为开展慢病管理、体重管理等，需要补充服务能力，增加获客和客户运营能力则选择此类别',
            icon: 'iconjiankangguanli iconfont',
            bgColor: '#8555CE',
            industryType: 4
        },
        {
            id: 6,
            name: '业务员',
            ms: '快速构架健康管理平台，便捷同步健康商品、权益卡库存，进行展业、拓客和用户运营',
            icon: 'iconyewuyuan iconfont',
            bgColor: '#2C70F6',
            industryType: 9
        },
        {
            id: 7,
            name: '医疗器械',
            ms: '我们会将您的产品分发给health force数万的医疗及健康管理机构',
            icon: 'iconyiliaoqixie iconfont',
            bgColor: '#C05BDA',
            industryType: 6
        },
        {
            id: 8,
            name: '保险公司',
            ms: '保险、TPA、保险经济公司等，便捷采购健康商品、权益卡等，快速构架健康管理平台；提供核保、健康大数据中台',
            icon: 'iconbaoxiangongsi iconfont',
            bgColor: '#AA8800',
            industryType: 8
        }
    ];

    /**
     * 店铺名称
     * @protected
     * @returns 
     */
    protected shopName: string = "";
    
    /**
     * 当前选择的分类
     * @protected
     * @returns 
     */
    protected industryTypeItem: any= {
        name: '',
        industryType: null
    };

    /**
     * 剩余可创建店铺
     * @protected
     * @returns 
     */
    protected remainingNum: number = 0;

    /**
     * 获取或设置用户服务。
     * @protected
     * @returns UserService
     */
    protected get userService(): UserService
    {
        if(!this._userService)
        {
            this._userService = this.$serviceProvier.resolve<UserService>(UserService);
        }

        return this._userService;
    }

    /**
     * 用户信息
     * @protected
     * @type {any}
     */
    protected get userInfo(): any {

        return this.$store.getters["global/userInfo"]
    }

    /**
     * 获取用户信息
     * @private
     * @return Promise<void>
     */
    private async getLoginInfo(): Promise<void>
    {
        try
        {
            let {content: result} = await this.userService.getLoginInfo();
            if(result.data)
            {
                // 存储登入所有信息
                this.$store.dispatch("user/setProfile", result.data);
                this.handleMenu(result.data);
            }
        } 
        catch(err)
        {
            
            this.$message.error({
                duration: 3,
                content: JSON.stringify(err)
            })
        }
    }

    /**
     * 处理菜单数据
     * @private
     * @return Promise<void>
     */
    private async handleMenu(profile: IUserLoginInfoModel): Promise<void>
    {
        if (profile.menus.length === 0) {
            this.$message.warning("您无菜单权限,请联系管理员");
            return;
        }
        localStorage.removeItem("app_menu");
        // 拿菜单信息
        let app_menu = localStorage.getItem("app_menu");
        let antDesignmenus
        if (!app_menu)
        {
            const applocation: Array<any> = [];
            // 应用信息
            profile.apps.forEach((item: IAppModel) =>
            {
                const apps:{
                    code: string,
                    name: string,
                    active: boolean,
                    menu: Array<IMenuModel>
                } = { code: '', name: '', active: true, menu: [] }
                if (item.active) {
                    apps.code = item.code
                    apps.name = item.name
                    apps.active = item.active
                    apps.menu = profile.menus
                    antDesignmenus = profile.menus
                } else {
                    apps.code = item.code
                    apps.name = item.name
                    apps.active = item.active
                    apps.menu = []
                }
                applocation.push(apps)
            })
            // 存储菜单缓存信息
            localStorage.setItem("app_menu", JSON.stringify(applocation))
        }
        else
        {
            // 取缓存数据
            antDesignmenus = app_menu && JSON.parse(app_menu)&&JSON.parse(app_menu)[0] && JSON.parse(app_menu)[0].menu || [];
        }
        
        this.$store.dispatch('global/generateRoutes', antDesignmenus).then(() =>
        {
            // 动态添加可访问路由表
            router.addRoutes(this.$store.getters["global/menuData"])
            this.$router.push({ name: 'console' });
            
        })
    }

    /**
     * 组件创建钩子。
     * @protected
     * @returns void
     */
    protected created(): void
    {
        // this.getMyTenants();
    }

    /**
   * 注销登录
   * @protected
   * @return void
   */
  protected async logout(): Promise<void> {
    try {
      await this.userService.logout();
    } catch (err) {
      this.$message.error({
        duration: 3,
        content: err || "服务器错误",
      });
    }
  }

    /**
     * 退出登录
     * @protected
     * @returns void
     */
    protected loginOut(): void
    {
        this.$confirm({
            title: "提示",
            content: "是否确定注销登录?",
            okText: "确定",
            cancelText: "取消",
            onOk: async () => {
                return await this.logout()
                .then(() => {
                    setTimeout(() => {
                        localStorage.clear();
                        this.$router.push("/")
                    }, 20);
                })
                .catch(() => {
                    this.$message.error("注销失败");
                });
            },
            onCancel() {},
        });
    }

    /**
     * 跳转店铺。
     * @protected
     * @returns void
     */
    protected onGoShop(item: any): void
    {
        this.$store.commit("global/SET_TENANT_ID", item.id);
        this.getLoginInfo();
    }
    /**
     * 个人设置
     * @protected
     * @returns void
     */
    protected accSet(): void
    {
        this.$router.push({name: "accountSettings"})
    }



    /**
     * 新增店铺
     * @protected
     * @returns 
     */
    protected onAddShop(item: any): void
    {   
        this.industryTypeItem = item;
        this.visible = true; 
    }

    /**
     * 新增店铺
     * @protected
     * @returns 
     */
    protected async handleSubmit(): Promise<void>
    {
        try
        {   
            if (this.shopName.trim() == '') 
            {
                 this.$message.error("请输入店铺名称!");
                 return;
            }
            await this.userService.addTenant({name: this.shopName, industryType: this.industryTypeItem.industryType})
            this.$message.success("新增成功!");
            this.shopName = "";
            this.visible = false;
            this.$router.push({name:'shop'})
        }
        catch(err)
        {
             this.$message.error({
                duration: 3,
                content: err || "服务器错误"
            })
        }
    }
     /**
     * 返回首页
     * @protected
     * @returns void
     */
    protected gotoIndex(): void
    {
       this.$router.push({name: 'shop'})
    }
}
